import type { Views } from '../../../types/views';
import type { Context, Events, States } from '../machine/types';

import { SignUp } from './SignUp/SignUp';

export const VIEWS: Views<Context, Events, States> = {
  ready: SignUp,
  chooseMethod: SignUp,
  submittingCredentials: SignUp,
  startingOAuth: SignUp,
  signUpSuccessful: SignUp,
  loginSelected: SignUp,
};
